import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const ONBOARDING_REFUSE_CANDIDATE = gql`
    mutation OnboardingRefuseCandidate($request: RefuseCandidateRequestDto!) {
        onboardingRefuseCandidate(request: $request) {
            uuid
            step
            refused
            refusalComment
            refusedAt
        }
    }
`;

const useOnboardingRefuseCandidate = () => {
    const [mutate, { loading, error }] = useMutation(ONBOARDING_REFUSE_CANDIDATE);

    const refuseCandidate = async (candidateUuid, refusalComment) => {
        return mutate({
            variables: {
                request: {
                    candidateUuid,
                    refusalComment,
                },
            },
        });
    };

    return {
        refuseCandidate,
        loading,
        error,
    };
};

export default useOnboardingRefuseCandidate;
